/**
 * @class FournisseurService
 */
function FournisseurService($log) {
    let self = this;

    const PROVIDERS = [
        {
            id: 14,
            fournisseur: 'AEM-Soft'
        },
        {
            id: 8,
            fournisseur: 'Aleda'
        },
        {
            id: 5,
            fournisseur: 'Autre'
        },
        {
            id: 6,
            fournisseur: 'Bimedia'
        },
        {
            id: 2,
            fournisseur: 'Casio'
        },
        {
            id: 9,
            fournisseur: 'CPI presse'
        },
        {
            id: 15,
            fournisseur: 'Crisalid'
        },
        {
            id: 11,
            fournisseur: 'Devlyx'
        },
        {
            id: 10,
            fournisseur: 'Devlyx-ABM'
        },
        {
            id: 12,
            fournisseur: 'Devlyx-Autre'
        },
        {
            id: 4,
            fournisseur: 'Inconnu'
        },
        {
            id: 21,
            fournisseur: 'JDC-Boulangerie'
        },
        {
            id: 18,
            fournisseur: 'LEO2'
        },
        {
            id: 17,
            fournisseur: 'MENLOG'
        },
        {
            id: 3,
            fournisseur: 'Non informatisé'
        },
        {
            id: 13,
            fournisseur: 'OMC Gervais'
        },
        {
            id: 20,
            fournisseur: 'ORCHESTRA'
        },
        {
            id: 19,
            fournisseur: 'POINTEX'
        },
        {
            id: 7,
            fournisseur: 'Sharp'
        },
        {
            id: 1,
            fournisseur: 'Strator'
        },
        {
            id: 22,
            fournisseur: 'SYNSEO'
        },
        {
            id: 16,
            fournisseur: 'TIGRA'
        }
    ];

    const MOTIFS =[
        {
            code: 'ACC',
            intitule: 'Accompagnement'
        },
        {
            code: 'CTE',
            intitule: 'Contraintes techniques'
        },
        {
            code: 'FDC',
            intitule: 'FDC trop éloignée'
        },
        {
            code: 'LOG',
            intitule: 'Logiciel'
        },
        {
            code: 'MAT',
            intitule: 'Matériel'
        },
        {
            code: 'PRI',
            intitule: 'Prix'
        },
        {
            code: 'QOS',
            intitule: 'QoS'
        },
        {
            code: 'SER',
            intitule: 'Service'
        },
    ];


    /**
     * Get fournisseur list
     * @returns {d.promise}
     */
    self.list = function() {
        return PROVIDERS;
    };

    self.motifs = function() {
        return MOTIFS;
    }

    return self;
}
FournisseurService.$inject = ['$log'];

angular.module('app.prospection.store.fournisseurService', []).factory('fournisseurService', FournisseurService);
